"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.number.constructor.js");

var _props = require("../../search/src/props");

var props = {
  // Element UI Table attributes
  height: [String, Number],
  maxHeight: [String, Number],
  size: {
    type: String,
    default: 'medium'
  },
  stripe: Boolean,
  border: {
    type: Boolean,
    default: true
  },
  fit: {
    type: Boolean,
    default: true
  },
  showHeader: {
    type: Boolean,
    default: true
  },
  highlightCurrentRow: {
    type: Boolean,
    default: true
  },
  currentRowKey: [String, Number],
  rowClassName: [String, Function],
  rowStyle: [String, Function],
  rowKey: [String, Function],
  emptyText: String,
  defaultExpandAll: Boolean,
  expandRowKeys: Array,
  defaultSort: Object,
  tooltipEffect: String,
  showSummary: Boolean,
  sumText: String,
  summaryMethod: Function,
  // custom attributes
  tableStyle: {
    type: String,
    default: 'width:100%;'
  },
  fetch: {
    type: Function
  },
  url: {
    type: String
  },
  method: {
    type: String,
    default: 'get',
    validator: function validator(value) {
      var methodTypes = ['get', 'post', 'put', 'delete'];
      return methodTypes.indexOf(value.toLowerCase()) !== -1;
    }
  },
  headers: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  listField: {
    type: String,
    default: 'data.data'
  },
  totalField: {
    type: String,
    default: 'data.data'
  },
  params: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  formOptions: {
    type: Object
  },
  autoLoad: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: 'remote',
    validator: function validator(value) {
      var types = ['remote', 'local'];
      var validType = types.indexOf(value) !== -1;

      if (!validType) {
        throw new Error("\u8BF7\u8BBE\u7F6E\u6570\u636E\u6765\u6E90\u65B9\u5F0F");
      }

      return validType;
    }
  },
  data: {
    type: Array
  },
  dataHandler: {
    type: Function
  },
  columns: {
    type: Array,
    required: true
  },
  showPagination: {
    type: Boolean,
    default: true
  },
  background: {
    type: Boolean,
    default: true
  },
  pageSizes: {
    type: Array,
    default: function _default() {
      return [20, 30, 50];
    }
  },
  pageTotal: {
    type: Number,
    default: 0
  },
  paginationLayout: {
    type: String,
    default: 'prev, pager, next, sizes'
  },
  pageIndexKey: {
    type: String,
    default: 'page'
  },
  pageSizeKey: {
    type: String,
    default: 'pagesize'
  }
}; // Object.keys(formProps).forEach(v => {
//   props.formOptions[v] = formProps[v]
// })

var _default2 = props;
exports.default = _default2;